'use client';
import React from 'react';

const industries = [
  {
    name: 'Finance',
    description: 'Protecting financial platforms with AI-led security assessment and expert DevSecOps engineering.',
    href: '/industries/financial-services',
  },
  {
    name: 'FinTech',
    description: 'Securing payment systems, APIs, and cloud-native architectures for fast-moving fintech companies.',
    href: '/industries/fintech',
  },
  {
    name: 'Technology',
    description: 'Securing innovation with AI-led security assessment and expert security teams.',
    href: '/industries/saas-tech',
  },
  {
    name: 'Telecom',
    description: 'Protecting networks, platforms, and millions of subscribers.',
    href: '/industries/telecom',
  },
  {
    name: 'Energy',
    description: 'Safeguarding critical infrastructure from advanced threats.',
    href: '/industries/critical-infrastructure',
  },
  {
    name: 'Healthcare',
    description: 'Protecting patient data and critical systems with AI-led security and HIPAA compliance.',
    href: '/industries/healthtech',
  },
  {
    name: 'SaaS',
    description: 'End-to-end DevSecOps for SaaS products from development to production.',
    href: '/industries/saas-tech',
  },
  {
    name: 'Manufacturing',
    description: 'Protecting production lines and digital supply chains.',
    href: '/industries/critical-infrastructure',
  },
];

export default function IndustriesSection() {
  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 mb-16">
          <div>
            <p className="font-mono-brand text-[0.7rem] text-[#80edfa] uppercase tracking-widest mb-4">
              Industries
            </p>
            <h2 className="font-heading text-[clamp(2rem,4vw,3rem)] text-[#f5f5f8] font-medium leading-tight">
              TechSonar operates where compliance pressure is highest
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-[#aaa] text-base leading-relaxed">
              Targeted DevSecOps expertise. Industry by industry.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-l border-[#222]">
          {industries?.map((industry, i) => (
            <a
              key={i}
              href={industry?.href}
              className="industry-card block p-8 border-b border-r border-[#222] group"
            >
              <div className="flex flex-col gap-4">
                <h3 className="font-heading text-lg text-[#f5f5f8] font-medium group-hover:text-[#80edfa] transition-colors duration-200">
                  {industry?.name}
                </h3>
                <p className="text-sm text-[#666] leading-relaxed">{industry?.description}</p>
                <div className="flex items-center gap-2 text-[#80edfa] opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <span className="font-mono-brand text-[0.65rem] uppercase tracking-widest">Learn more</span>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6H10M7 3L10 6L7 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
